import { Button, ButtonProps, styled, Theme } from "@mui/material";
import { MobileView } from "../../../util/aKaunGeneralUtil";
import * as React from "react";
import { commonBoxShadowStyle } from "fe-common/ui/boxShadow";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";

export interface BottomNavigationButtonProps {
  main?: "true" | "false";
  wizard?: "true" | "false";
  height?: string;
  align?: "left" | "center" | "right";
}
export const BottomNavigationButton = styled(
  ({ ...props }: { main?: string; dim?: string }) => (
    <Button variant={"contained"} color={"primary"} {...props} />
  ),
)(
  ({
    theme,
    ...props
  }: { theme?: Theme } & BottomNavigationButtonProps & ButtonProps) => ({
    fontSize: "18px",
    fontWeight: 500,
    textTransform: "none",
    textAlign: "center",
    justifyContent: props.align ? "flex-start" : "center",
    background: props.disabled
      ? "rgba(0, 0, 0, 0.12)"
      : props.main === "true"
      ? KahunColorMap.Primary
      : "transparent",
    color: props.disabled
      ? "rgba(0, 0, 0, 0.26)"
      : props.main === "true"
      ? KahunColorMap.White
      : KahunColorMap.PrimaryDim,
    "&:hover": {
      backgroundColor: KahunColorMap.Primary,
      opacity: 0.7,
      color: KahunColorMap.White,
    },
    width: "100%",
    height: props.height ?? "100%",
    borderRadius: 0,
    [theme.breakpoints.down(MobileView)]: {
      padding: "10px",
      marginRight: props.main === "true" ? 0 : "6px",
      "& i": {
        marginRight: "10px",
      },
      flex: 1,
    },
  }),
);

export const RoundBottomNavigationButton = styled(BottomNavigationButton)(
  ({ theme }) => ({
    borderRadius: "8px",
    ...commonBoxShadowStyle,
    [theme.breakpoints.down(MobileView)]: {
      // Keep opacity:1 for mobile to avoid "disabled" look being stuck
      "&:hover": {
        opacity: 1,
      },
    },
  }),
);

export const RosebudMobileBottomNavigationHeight = 65;

export const MobileDiagnoseButton = styled(
  ({
    ...props
  }: {
    children?: any;
    onClick: () => void;
    disabled?: boolean;
  }) => <RoundBottomNavigationButton main="true" {...props} />,
)({});

export const MobileDiagnoseButtonContainer = styled("div")(({ theme }) => ({
  [theme.breakpoints.down(MobileView)]: {
    width: "100%",
    minHeight: `${RosebudMobileBottomNavigationHeight}px`,
    display: "flex",
    padding: "10px",
    borderTop: "1px solid rgb(235, 235, 235)",
    backgroundColor: "white",
    alignContent: "center",
    justifyContent: "center",
    position: "fixed",
    bottom: 0,
    left: 0,
  },
}));
